"use client"
import {CustomerScrollRestorationProvider} from '@fitro/customer-features/components/providers/CustomerScrollRestorationProvider'
import type {ReactNode} from 'react'
import {usePathname} from 'next/navigation'
import {QueryClientProvider} from '@fitro/customer-features/components/providers/QueryClientProvider'
import {I18nProvider} from '@fitro/customer-features/components/providers/I18nProvider'
import {ThemeProvider} from '@fitro/customer-features/components/providers/ThemeProvider'
import {PreferencesProvider} from '@fitro/customer-features/components/providers/PreferencesProvider'
import {NotificationsProvider} from '@fitro/customer-features/components/providers/NotificationsProvider'
import {BuildVersionGuard} from '@/components/providers/BuildVersionGuard'
import {PenInteractionFallback} from '@fitro/customer-features/components/providers/PenInteractionFallback'
import {PointerDebugLogger} from '@fitro/customer-features/components/debug/PointerDebugLogger'
import {JourneyContextProvider} from '@fitro/customer-features/components/providers/JourneyContextProvider'
import {plMessages} from '@fitro/customer-features/lib/i18n'

const CLIENT_MESSAGES = {pl: plMessages}

export function Providers({children}: {children: ReactNode}) {
    return <CustomerScrollRestorationProvider><ApplicationProviders>{children}</ApplicationProviders></CustomerScrollRestorationProvider>
}

function ApplicationProviders({children}: {children: ReactNode}) {
    if (usePathname() === '/embed') return children

    return (
        <QueryClientProvider>
            <I18nProvider
                defaultLocale="pl"
                messages={CLIENT_MESSAGES}
                storageKey="fitro-locale"
                timeZone="Europe/Warsaw"
            >
                <ThemeProvider
                    defaultTheme="light"
                    storageKey="fitro-theme"
                >
                    <PreferencesProvider>
                        <JourneyContextProvider>
                            <NotificationsProvider>
                                <PenInteractionFallback />
                                <PointerDebugLogger />
                                <BuildVersionGuard />
                                {children}
                            </NotificationsProvider>
                        </JourneyContextProvider>
                    </PreferencesProvider>
                </ThemeProvider>
            </I18nProvider>
        </QueryClientProvider>
    )
}
